import { PasswordInput, Text } from 'shell/components';

const PasswordInputDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>PasswordInput</Text>
            <PasswordInput defaultValue={'Password1234!'} />
        </>
    );
};

export default PasswordInputDemo;
